// Making a new JS component
// 1 - Replace filterSearch with new name ( 8 occurences in this file )
// 2 - All code goes into init()
// 3 - Save file as new name .js
var filterSearch = {
	name: 'filterSearch',
	componentInitSelector: '.filterSearch',
	registerComponent: function() {
		if ( $(filterSearch.componentInitSelector).length ) {
			framework.registerComponent(filterSearch);
		}
	},
	initFilterSearch: function() {
        // Put your args and inits here with their options.

        // End
        log(config.application.name + " •• filterSearch in " + Math.round( performance.now() - framework.initComponents.componentInitTime) + " milliseconds" );
    },
	init: function() {
		// All code for this component goes in here

	$('input.quicksearch').on("focus", function(){
		$('a.go').toggleClass('is-active');
	});
	  

		// End
		filterSearch.initFilterSearch();  
	}
}

// Register self to the framework
filterSearch.registerComponent();